import axios from "axios";

const getDefaultState = () => {
  return {
    programsLoading: "empty",
    programs: [],
    results: [],
  };
};
const state = getDefaultState;

const getters = {
  getEduPrograms: (state) => {
    return state.programs;
  },
  getEduProgramsLoading: (state) => {
    return state.programsLoading;
  },
  getUserResults: (state) => {
    return state.programsLoading;
  },
};

const mutations = {
  resetEduState(state) {
    Object.assign(state, getDefaultState());
  },
  setPrograms: (state, programsArray) => {
    state.programs = programsArray;
  },
  setLoadingProgramsState: (state, bool) => {
    state.programsLoading = bool;
  },
};

const actions = {
  resetEducationData({ commit }) {
    commit("resetEduState");
  },
  async setEducationTree({ commit }) {
    commit("setLoadingProgramsState", true);
    let { data } = await axios.get("get-education-program");
    commit("setPrograms", data.data);
    commit("setLoadingProgramsState", false);
  },
};

export default {
  state,
  mutations,
  actions,
  getters,
};
